module.exports = __webpack_public_path__ + "static/media/TeamWork.690323e4.png";